// useTagging.js

import { useEffect,useState } from 'react';

/**
 * Custom hook for handling "@" detection and tagging logic.
 */
export function useTagging(editableRef) {
  const [isTagging, setIsTagging] = useState(false);
  const [tagQuery, setTagQuery] = useState('');
  const [showTagPopup, setShowTagPopup] = useState(false);

  useEffect(() => {
    // We remove the unused 'e' parameter to fix the "defined but never used" error.
    const handleKeyUp = () => {
      if (!editableRef?.current) return;

      const editorText = editableRef.current.textContent || "";

      // If the text ends with "@ " (user just typed space after @), never open
      if (/@\s$/.test(editorText)) {
        setIsTagging(false);
        setTagQuery('');
        setShowTagPopup(false);
        return;
      }

      const selection = window.getSelection();
      if (!selection || selection.rangeCount === 0) {
        setIsTagging(false);
        setTagQuery('');
        setShowTagPopup(false);
        return;
      }

      const anchorNode = selection.anchorNode;
      if (!anchorNode) {
        setIsTagging(false);
        setTagQuery('');
        setShowTagPopup(false);
        return;
      }

      const textContent = anchorNode.textContent || "";
      const atIndex = textContent.lastIndexOf('@');
      if (atIndex >= 0) {
        const query = textContent.slice(atIndex + 1);
        // If a space immediately follows "@", do not trigger tagging
        if (textContent.charAt(atIndex + 1) === ' ') {
          setIsTagging(false);
          setTagQuery('');
          setShowTagPopup(false);
          return;
        }
        // If there's a space anywhere else in the query, also block
        if (query.indexOf(' ') !== -1) {
          setIsTagging(false);
          setTagQuery('');
          setShowTagPopup(false);
        } else {
          setIsTagging(true);
          setTagQuery(query);
          setShowTagPopup(true);
        }
      } else {
        setIsTagging(false);
        setTagQuery('');
        setShowTagPopup(false);
      }
    };

    const el = editableRef?.current;
    if (el) {
      el.addEventListener("keyup", handleKeyUp);
    }
    return () => {
      if (el) {
        el.removeEventListener("keyup", handleKeyUp);
      }
    };
  }, [editableRef]);

  return {
    isTagging,
    tagQuery,
    showTagPopup,
    setShowTagPopup,
    setIsTagging,
    setTagQuery
  };
}
